module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "p2",
      "title": "2"
    }
  }, [_c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Copyright © 2016 by General Mills, Minneapolis, Minnesota. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.hmhco.com",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data is available.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("ISBN 978-0-544-81624-4")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Cover photos: "), _c('span', {
    attrs: {
      "href": "#/html/p278#p278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Fruit Frozen Yogurt Pops")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/html/p161#p161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesy Turkey-Spinach Lasagna Roll-Ups")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("GENERAL MILLS")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Owned Media and Publishing Director: Amy Halford")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Owned Media and Publishing Manager: Audra Carson")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Senior Editor: Grace Wells and Cathy Swanson")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Recipe Development and Testing: Betty Crocker Kitchens")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Photography: General Mills Photography Studios and Image Library")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("HOUGHTON MIFFLIN HARCOURT")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Publisher: Natalie Chapman")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Editorial Director: Cindy Kitchel")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Executive Editor: Anne Ficklen")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Editorial Associate: Molly Aronica")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Managing Editor: Marina Padakis")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Production Editor: Helen Seachrist")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Cover Design: Tai Blanche")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Interior Design and Layout: Tai Blanche")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Senior Production Coordinator: Kimberly Kiefer")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("eISBN 978-0-544-81625-1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("v1.0816")]), _vm._v(" "), _c('div', {
    staticClass: "figurecp"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/p002.png"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3e44fb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/p002.vue
// module id = 60
// module chunks = 0